module.exports = __webpack_public_path__ + "img/en-mb-s4.4df71c97.png";